'use client'

import { useAsset } from '@marketplace-web/shared/assets'
import { PrivacyCardModel } from '@marketplace-web/user-agreements/privacy-center-data'

const usePrivacyControlCardContent = () => {
  const asset = useAsset('/assets/privacy-center/privacy-control-section')

  const cardManageNotifications = asset('bell-48.svg')
  const cardAdjustPersonalisation = asset('settings-48.svg')
  const cardUpadeCookie = asset('cookie-48.svg')
  const cardDownloadData = asset('document-48.svg')

  const privacyControlCards: Array<PrivacyCardModel> = [
    {
      imageSrc: cardManageNotifications,
      title: 'privacy_center.control_privacy_section.manage_notifications.title',
      description: 'privacy_center.control_privacy_section.manage_notifications.description',
      link: 'privacy_center.control_privacy_section.manage_notifications.link',
      link_a11y: 'privacy_center.control_privacy_section.manage_notifications.link_a11y',
    },
    {
      imageSrc: cardAdjustPersonalisation,
      title: 'privacy_center.control_privacy_section.adjust_personalisation.title',
      description: 'privacy_center.control_privacy_section.adjust_personalisation.description',
      link: 'privacy_center.control_privacy_section.adjust_personalisation.link',
      link_a11y: 'privacy_center.control_privacy_section.adjust_personalisation.link_a11y',
    },
    {
      imageSrc: cardUpadeCookie,
      title: 'privacy_center.control_privacy_section.update_cookie_preferences.title',
      description: 'privacy_center.control_privacy_section.update_cookie_preferences.description',
      link: 'privacy_center.control_privacy_section.update_cookie_preferences.link',
      link_a11y: 'privacy_center.control_privacy_section.update_cookie_preferences.link_a11y',
    },
    {
      imageSrc: cardDownloadData,
      title: 'privacy_center.control_privacy_section.download_data.title',
      description: 'privacy_center.control_privacy_section.download_data.description',
      link: 'privacy_center.control_privacy_section.download_data.link',
      link_a11y: 'privacy_center.control_privacy_section.download_data.link_a11y',
    },
  ]

  return privacyControlCards
}

export default usePrivacyControlCardContent
